import { useState, useRef } from "react"
import { Player } from "../classes/player"

export function ToggleOutfit() {
	const btnTopRef = useRef<HTMLButtonElement>(null)
	const [iconSrc, setIconSrc] = useState("assets/DisplayOutfit.svg") // Initial icon path

	function toggle() {
		if (iconSrc === "assets/DisplayOutfit.svg") {
			setIconSrc("assets/HideOutfit.svg")
			Player.toggleTop(false)
		} else {
			setIconSrc("assets/DisplayOutfit.svg")
			Player.toggleTop(true)
		}
	}

	const handleDivClick = () => {
		btnTopRef.current?.click()
	}

	return (
		<div id="toggleDisplayOutfit" onClick={handleDivClick}>
			Display Outfit
			<button id="btnDisplayOutfit" ref={btnTopRef} onClick={toggle}>
				<img src={iconSrc} alt="Top Toggle Icon" />
			</button>
		</div>
	)
}

